export const optionOpenStreetMap = {
  attribution:
    'Map data: &copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors'
};

export const optionsBaseMeteocat = {
  maxZoom: 10,
  minZoom: 8,
  attribution: 'Imagery © <a href="http://www.meteo.cat/">Meteocat</a>',
  dimX: "000",
  dimY: "000",
  tms: true
};
